import React, { ReactNode } from 'react';
import { Box, Button } from '@mui/material';
import { Clear as ClearIcon, FilterAlt as FilterIcon, Search as SearchIcon } from '@mui/icons-material';

interface SearchActionButtonsProps {
  onClear: () => void;
  onSearch?: () => void;
  clearLabel?: string;
  searchLabel?: string;
  searchIcon?: ReactNode;
}

/**
 * 検索アクションボタン（検索ボタンとクリアボタン）を表示するコンポーネント
 * 一覧画面で使用する検索関連の操作ボタンを担当
 */
const SearchActionButtons: React.FC<SearchActionButtonsProps> = ({ 
  onClear, 
  onSearch,
  clearLabel = 'クリア', 
  searchLabel = '検索',
  searchIcon
}) => {
  // 検索アイコンがない場合はデフォルトのアイコンを使用
  const icon = searchIcon || <SearchIcon />;
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
      <Button
        type="button"
        variant="outlined"
        color="secondary"
        startIcon={<ClearIcon />}
        onClick={onClear}
      >
        {clearLabel}
      </Button>
      
      <Button
        type={onSearch ? "button" : "submit"}
        variant="contained"
        color="primary"
        startIcon={icon}
        onClick={onSearch}
        sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}
      >
        {searchLabel}
      </Button>
    </Box>
  );
};

export default SearchActionButtons;